/**
 * THE ONE MIRROR HELPER (ADR 0009 / phase brief section 3). Mirroring is
 * about the asset's own centre: translate(cx,0) scale(-1,1) translate(-cx,0)
 * where cx = x + width/2. Getting the axis wrong silently teleports the
 * asset across the drawing — it happened three times in the prototype and
 * never threw — so hand-written mirror transforms are forbidden
 * (assets:validate and a lint grep both reject `scale(-1` outside this
 * module) and every caller goes through here.
 */
export function mirrorTransform(x, width) {
    const cx = x + width / 2;
    return `translate(${fmt(cx)},0) scale(-1,1) translate(${fmt(-cx)},0)`;
}
/** Compact number formatting so serialized output stays byte-stable. */
function fmt(n) {
    const rounded = Math.round(n * 100) / 100;
    return Object.is(rounded, -0) ? "0" : String(rounded);
}
//# sourceMappingURL=mirror.js.map